// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from './State.types.tsx';

const setHasOpened =
	(): Action<State> =>
	({ getState, setState }) => {
		const { hasOpened } = getState();

		if (hasOpened === true) {
			// if state has been updated already return
			return;
		}

		setState({ hasOpened: true });
	};

export default setHasOpened;
